import { CSSObject } from '@chakra-ui/react';
import { TLinkContainer } from './NextToJumpItem.styles';

export const LinkContainer = ({ isLast }: TLinkContainer) => ({
  borderBottom: '1px dashed',
  borderBottomColor: 'blackAlpha.400',
  boxShadow: !isLast && '0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
  borderRadius: 'unset',
  px: '0',
  py: '2',
  mb: 'unset',
  mx: '2',
  w: 'auto',
  mt: '-0.5',
  bg: 'transparent',
  filter: 'drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.25))',
  _hover: {
    bg: 'blackAlpha.100',
  },
});

export const BoxNextToJumpContainer: CSSObject = {
  bg: 'rgba(0, 209, 255, 0.25)',
  mx: '0',
  borderBottom: '1px dashed',
  borderRadius: 'md',
  mb: '2',
  boxShadow:
    '0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset, 0px 4px 6px 0px rgba(0, 0, 0, 0.15)',
};

export const Icon: CSSObject = {
  boxSize: '8',
  color: 'beta.700',
  bgGradient: 'linear(to-b, beta.300, beta.400)',
  border: 'none',
  borderRadius: 'base',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.4)',
  p: '1.5',
};

export const TextRace: CSSObject = {
  color: 'white',
  textTransform: 'capitalize',
  fontFamily: 'accent',
  fontSize: 'sm',
  fontStyle: 'normal',
  lineHeight: 'normal',
  fontWeight: 'semibold',
};

export const TextNumber: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bg: 'gray.200',
  color: 'gray.600',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  py: '0',
  borderRadius: 'base',
  '&&': {
    h: '18px',
    maxH: '18px',
    minH: '18px',
    lineHeight: '18px',
  },
};

export const BoxHeading: CSSObject = {
  display: 'none',
};

export const FlexWrapper: CSSObject = {
  '.state-inprogress': {
    color: ['white', 'beta.900'],
  },
  '.chakra-badge': {
    borderRadius: 'sm',
    h: '4',
    minH: '4',
    py: '0',
    mr: '0.5',
    color: 'alpha.800',
  },
};
